import React from 'react';
import { LoaderSubmitButton } from '../../../components/LoaderSubmitButton';

export const RevertToActiveButton = ({ jobId, loading, updateStatus }) => (
  <LoaderSubmitButton
    data-test-id={`revert-to-active-${jobId}`}
    loading={loading}
    size="small"
    color="primary"
    onClick={() => {
      updateStatus(jobId, 'active');
    }}
  >
    Revert to Active
  </LoaderSubmitButton>
);
